import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAuth } from '../../../auth'

export type EmpresaDaTela = {
  id: number
  nome: string
}

/**
 * Empresa da tela de protocolos (T7a). O front não tem "empresa ativa" global: as opções saem dos
 * vínculos do usuário e a escolhida vai na query string, para o link do detalhe ser estável.
 */
export const useEmpresaDaTela = () => {
  const { currentUser } = useAuth()
  const [parametros, setParametros] = useSearchParams()

  const empresas = useMemo<EmpresaDaTela[]>(() => {
    const mapa = new Map<number, string>()
    ;(currentUser?.vinculos ?? []).forEach((vinculo) => {
      const empresa = vinculo?.empresa
      if (empresa?.id) {
        mapa.set(
          Number(empresa.id),
          empresa.nomeFantasia ?? empresa.nome ?? `Empresa ${empresa.id}`
        )
      }
    })
    return Array.from(mapa.entries()).map(([id, nome]) => ({ id, nome }))
  }, [currentUser])

  const daQueryString = Number(parametros.get('empresa'))
  const idEmpresa = daQueryString && !Number.isNaN(daQueryString) ? daQueryString : empresas[0]?.id

  const selecionarEmpresa = (id: number) => {
    parametros.set('empresa', String(id))
    setParametros(parametros)
  }

  return { idEmpresa, empresas, selecionarEmpresa }
}
